import React, { useState, useEffect } from 'react';

import { getCostCentres, getTitles } from 'api';
import {
  csvToCodeLabelOptions,
  csvToCostCentreCodeLabelOptions,
} from 'csvUtils/csvToJson';

const EnsembleListContext = React.createContext({
  costCentreMap: {},
  costCentreOptions: [],
  titleOptions: [],
});

function EnsembleListProvider({ children }) {
  const [costCentreMap, setCostCentreMap] = useState({});
  const [costCentreOptions, setCostCentreOptions] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);

  useEffect(() => {
    getCostCentres().then((response) => {
      if (response) {
        const options = csvToCostCentreCodeLabelOptions(response.data);
        setCostCentreOptions(options);
        const map = {};
        options.forEach(({ code, label }) => {
          map[code] = label;
        });
        setCostCentreMap(map);
      }
    });

    getTitles()
      .then((titles) => {
        if (titles) {
          setTitleOptions(csvToCodeLabelOptions(titles.data));
        }
      })
      .catch(() => {
        setTitleOptions([]);
      });
  }, []);

  return (
    <EnsembleListContext.Provider
      value={{ costCentreMap, costCentreOptions, titleOptions }}
    >
      {children}
    </EnsembleListContext.Provider>
  );
}

export { EnsembleListContext, EnsembleListProvider };
